import { render, staticRenderFns } from "./RelatorioLpsNaoVisitaList.vue?vue&type=template&id=40f40ab9&scoped=true"
import script from "./RelatorioLpsNaoVisitaList.vue?vue&type=script&lang=js"
export * from "./RelatorioLpsNaoVisitaList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLpsNaoVisitaList.vue?vue&type=style&index=0&id=40f40ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f40ab9",
  null
  
)

export default component.exports